import { GetStaticProps } from "next";

import { fetchPageBySlug } from "@clients/contentfulClient";
import Layout from "@containers/Layout/layout";

import { GetSiteTreeStructure } from "services/SiteTreeStructureFactory";
import { UrlStructureService } from "services/UrlStructureService";
import { getLayoutData } from "services/layoutService";

import ErrorPage from "../containers/ErrorPage";

const InternalServerError = ({ page, layoutData }: any): React.ReactNode => {
  return (
    <Layout {...layoutData}>
      <ErrorPage pageData={page.slug?.data} errorCode={500} />
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const preview = process.env.FORCE_PREVIEW === "true" || context.preview || false;

  const [urlStructure, siteTreeStructure] = await Promise.all([
    UrlStructureService(preview),
    GetSiteTreeStructure(preview),
  ]);

  const page = await fetchPageBySlug(urlStructure, "nagonting-gick-fel", 1, preview);

  const layoutData = await getLayoutData(
    urlStructure,
    siteTreeStructure,
    "/nagonting-gick-fel",
    preview,
    false
  );

  return {
    props: {
      page,
      layoutData,
    },
    revalidate: 10,
  };
};

export default InternalServerError;
